import { GlobalTask } from '../../domain/global-task';
import { mapper } from '../../tools/mapping/mapper';
import { GlobalTaskEntity } from '../entity';
import type { AppDB } from '../db';

export class GlobalTaskRepository {
    constructor(private readonly database: AppDB) {}


    async clearGlobalTaskById(ids: number[]) {
        await this.database.globalTasks.where('Id').anyOf(ids).toArray(async te => {
            for (let i = 0; i < te.length; i++) {
                if (te && te[i].Id !== undefined) {
                    await this.database.globalTasks.where('Id').equals(te[i].Id!).delete();
                }
            }
        })
    }

    async getGlobalTaskEntityById(id: number) {
        return await this.database.globalTasks.where('Id').equals(id).first(async gte => {
            const gt = mapper.map(gte, GlobalTaskEntity, GlobalTask);
            return gt;
        });
    }

    async getGlobalTaskListByProcessMeasureCode(processCode: string) {
        return await this.database.process.where('Code').equals(processCode).first(async pe => {

            const list: GlobalTask[] = [];
            if (pe?.GlobalTaskIds) {
                for (let i = 0; i < pe.GlobalTaskIds.length; i++) {
                    list.push(await this.database.getGlobalTaskEntityById(pe.GlobalTaskIds[i]));
                }
            }

            return list;
        });
    }

    async attachGlobalTask(task: GlobalTask, processId: number) {
        let taskId: number;
        const te = mapper.map(task, GlobalTask, GlobalTaskEntity);

        const pe = await this.database.getProcessEntityById(processId);
        taskId = await this.database.globalTasks.add(te);
        await this.database.process.update(processId, {
            GlobalTaskIds: pe?.GlobalTaskIds ? [...pe.GlobalTaskIds, taskId] : [taskId]
        });

        return taskId;
    }

    async addGlobalTask(task: GlobalTask, processCode: string) {
        let taskId: number;
        const te = mapper.map(task, GlobalTask, GlobalTaskEntity);

        const pe = await this.database.getProcessEntityByCode(processCode);
        if (pe && pe.Id) {

            taskId = await this.database.globalTasks.add(te);
            await this.database.process.update(pe?.Id, {
                GlobalTaskIds: pe?.GlobalTaskIds ? [...pe.GlobalTaskIds, taskId] : [taskId]
            });

            return taskId;
        }

        return null;
    }
}
